import React, { useEffect, useState, useMemo } from 'react';
import { Button, Tooltip } from 'src/components/ui';
import Icon from '../Icon';

function ToolbarButton(props) {
  const { className, iconClassName, title, tooltip, onClick, disabled, icon: propIcon } = props;
  const id = `Toolbar${title}Button`;

  const [hover, setHover] = useState(false);

  // Clear hover once button is disabled, prevents phantom tooltips
  useEffect(() => {
    if (disabled) {
      setHover(false);
    }
  }, [disabled]);

  // Only tracks hover on enabled buttons
  const toggleHover = () => {
    if (!disabled) {
      setHover(hover => !hover);
    }
  };

  const icon = useMemo(() => {
    if (propIcon) return propIcon;
    if (iconClassName) {
      return (
        <Icon
          icon={iconClassName}
          className={iconClassName}
          style={{
            position: 'relative',
            fontSize: '1rem',
          }}
        />
      );
    }
    return null;
  }, [iconClassName, propIcon]);

  return (
    <>
      <Button
        id={id}
        className={className}
        title={title}
        onClick={onClick}
        disabled={disabled}
        onMouseEnter={toggleHover}
        onMouseLeave={toggleHover}
        size="sm"
        style={{
          textAlign: 'center',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {icon}
      </Button>
      {tooltip ? (
        <Tooltip placement="bottom" isOpen={hover} target={id} toggle={toggleHover} fade={false}>
          {tooltip}
        </Tooltip>
      ) : null}
    </>
  );
}

export default ToolbarButton;
